import { render } from "./RssProxy.vue?vue&type=template&id=16270ea4&scoped=true"
import script from "./RssProxy.vue?vue&type=script&lang=js"
export * from "./RssProxy.vue?vue&type=script&lang=js"

import "./RssProxy.vue?vue&type=style&index=0&id=16270ea4&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16270ea4"]])

export default __exports__